import dayjs from 'dayjs';
import { IUser } from 'app/shared/model/user.model';
import { IProductDeliveryStatus } from 'app/shared/model/product-delivery-status.model';
import { ITransactionDetails } from 'app/shared/model/transaction-details.model';

export interface IUserPurchasedPlans {
  id?: number;
  planEndDate?: string | null;
  planStartDate?: string | null;
  user?: IUser;
  productDeliveryStatus?: IProductDeliveryStatus;
  transactionDetails?: ITransactionDetails;
}

export const defaultValue: Readonly<IUserPurchasedPlans> = {};
